<template>
  <div class="apj-page-contact">
    <div class="container">
      <div class="contact">
        <div
          class="item"
          v-for="(item, index) in contact"
          :key="index"
          :class="{
            'has-anime': item.anime,
          }"
          @click="trigger(item.event)"
        >
          <el-image :src="item.icon"></el-image>
          <div class="title">{{ item.title }}</div>
          <div class="wrapper">
            <div class="info">
              <div class="title-sub pi-fw-900">{{ item.subTitle }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
            <div class="action">
              <div class="btn" slot-reference>立即预约</div>
            </div>
          </div>
        </div>
      </div>

      <el-dialog title="联系我们" class="contact-dialog" :visible.sync="dialogFormVisible">
        <el-image style="text-align: center;" :src="contactQrImg"></el-image>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "apj-page-contact",
  data() {
    return {
      form: {

      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      contactQrImg: require('@/assets/site/dp_qr.png'),
      contact: [
        {
          icon: require("@/assets/images/service/xunjia.png"),
          title: "咨询价格",
          subTitle: "",
          text: "可为全国各地的伙伴提供紧密配合的上门服务与支持",
          event: "price",
          anime: true,
        },
        {
          icon: require("@/assets/images/service/yanshi.png"),
          title: "预约演示",
          subTitle: "",
          text: "为企业提供紧密配合的上门服务与支持",
          event: "show",
          anime: true,
        },
        {
          icon: require("@/assets/images/service/lianxi.png"),
          title: "联系电话",
          subTitle: "0756-6338632",
          text: "7x24小时不间断技术服务热线支持",
          event: "phone",
        },
      ],
    };
  },
  methods: {
    trigger(eventName) {
      //   console.log("trigger(eventName) ... " , eventName);
      if (!eventName) {
        console.error("event name not allow null.");
        return;
      }
      if (!this[eventName]) {
        console.error("event not found.");
        return;
      }
      this[eventName]();
    },
    price() {
      this.dialogFormVisible = true
      console.log("here is price.");
    },
    show() {
      this.dialogFormVisible = true
      console.log("here is show.");
    },
  },
};
</script>


<style lang="scss" scoped>
@import url("https://at.alicdn.com/t/font_2425752_agu6ou9vlug.css");
@import "@/assets/theme.scss";

/**  replace element css */
.el-backtop {
  position: initial;
}

/** apj-page-contact */
.contact-dialog {
  width:850px;
  margin-left:calc(calc(100% - 850px) / 2);
}
.contact-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align:left;
}

.apj-page-contact {
  .contact {
    width: 100%;
    display: flex;
    padding: 100px 0;
    // justify-content: space-around;
    justify-content: space-between;

    .item {
      // width: 33.3%;
      width: 300px;
      cursor: pointer;

      .el-image {
        width: 80px;
        height: 80px;
      }
      .title {
        font-size: 30px;
        line-height: 1.5em;
        margin-bottom: 15px;
        color: #333;
        font-weight: bold;
      }
      .wrapper {
        width: 100%;
        height: 60px;
        overflow: hidden;

        .info {
          height: 60px;
          transition: all 0.3s;

          .title-sub {
            font-size: 24px;
            line-height: 1.5em;
            color: $color-text-primary;
          }
          .text {
            font-size: 14px;
            line-height: 1.5em;
            color: #999;
          }
        }

        .action {
          height: 60px;
          display: flex;
          justify-content: center;
          .btn {
            border: 1px solid $color-text-primary;
            color: $color-text-primary;
            border-radius: 50px;
            width: 200px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 24px;
            &:hover {
              background-color: $color-bg-primary;
              color: $color-text-white;
            }
          }
        }
      }
      &.has-anime:hover {
        .info {
          margin-top: -60px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apj-page-contact/index.vue